import React from 'react'
import ReactTurntable from './ReactTurntable/ReactTurntable'
import { useSelector, useDispatch } from 'react-redux'
// import { setResultSelected } from "../redux/homepage/actions"
// import ReactGA from 'react-ga'
import { isMobileOnly } from 'react-device-detect'
import { fontSizes } from './ReactTurntable/TurntableFontSize'
// import Profiler from './ReactProfiler'
// import "react-turntable/assets/index.css"
// import { fadeIn } from "react-animations"
// import styled, { keyframes } from "styled-components"
import withLocation from './HOC/withLocation'
import ReactTurntableColorWheel from './ReactTurntable/ReactTurntableColorWheel'
import ColorWheelData from '../Data/ColorWheelData'
import spinButtonImages from '../component/ToolSettings/SpinButton/imageData'
import { useGeneralModal } from '../contextHook/generalModal'

// const fadeInAnim = keyframes`${fadeIn}`

// const Container = styled(Box)`
//   animation: 2s ${fadeInAnim};
// `

const options = {
  // width: 550,
  // height: 550,
  // primaryColor: "#2b580c",
  // secondaryColor: "#f7b71d",
  fontStyle: {
    color: '#fff',
    size: isMobileOnly ? 26 : 38,
    fontVertical: true,
    fontWeight: '400',
    fontFamily: `"Teachers", -apple-system, BlinkMacSystemFont, avenir next, avenir, segoe ui,
    helvetica neue, helvetica, Ubuntu, roboto, noto, arial, sans-serif`,
  },
  // speed: 30,
  // duration: 6000,
  clickText: 'SPIN',
  // onStart() {
  //   EventGA({
  //     category: "User Actions",
  //     action: "Spin The Wheel",
  //   })
  //   //If you want before the rotate do some...
  //   //If you want stop rotate you can return false
  //   return true
  // },
  //   onComplete(prize) {
  //   },
}

const Turntable = props => {
  const {
    choices,
    size,
    completed,
    weights = null,
    gaEvent = { category: 'User Actions', action: 'Spin The Wheel' },
    mute = null,
    started,
    isEmb = false,
    isBlog = false,
    weightOn = false,
    wheelColors = ['#2b580c', '#f7b71d', '#afa939', '#fdef96'],
    fontFamily = '',
    images = null,
    fontSize = null,
    fullScreenActive = false,
    isBlankWheel = false,
    page = '',
  } = props
  const mysterySpin = useSelector(
    state => state.settings.spinBehavior.mysterySpin,
  )
  const inputMethod = useSelector(state => state.rcw.inputMethod)
  const dispatch = useDispatch()
  // options.speed = randomIntFromInterval(3, 5) * 1000
  // options.duration = randomIntFromInterval(4, 6) * 1000
  const isRCW = props.urlLocation.pathname.includes('random-color-generator')
  const isICP = props.urlLocation.pathname.includes('instagram-comment-picker')
  const choicesICP = useSelector(state => state.icp.choices)
  const winnersLength = choicesICP.filter(
    item => item.filtered && item.place !== 0,
  ).length
  const restParticipants = choicesICP.filter(
    item => item.filtered === false,
  ).length
  const numWinners = useSelector(state => state.icp.numWinners)
  const { setNoActionModal } = useGeneralModal()

  const start = () => {
    if (
      isICP &&
      choicesICP.length > 0 &&
      (winnersLength >= numWinners || restParticipants === 0)
    ) {
      setNoActionModal({
        title: 'Unable to Spin',
        message:
          'All winners for this round have been selected. Click "Redraw" to start a new round before you can spin again.',
        buttonText: 'OK',
      })
      return false
    }
    started && started()
    // EventGA(gaEvent)   //turn off this gaEvent, because it hits GA monthly limits. //12Nov2020
    //If you want before the rotate do some...
    //If you want stop rotate you can return false
    return true
  }
  let music = null
  if (mute !== null) {
    if (mute === true) {
      music = {
        soundOn: false,
        starting: 'no-sound',
        spinning: 'no-sound',
        celebrating: 'no-sound',
      }
    } else {
      music = {
        soundOn: true,
        starting: 'button-sound',
        spinning: 'tick-sound',
        celebrating: 'celebration-sound',
      }
    }
  }

  if (fontFamily) {
    options.fontStyle.fontFamily =
      fontFamily + ', ' + options.fontStyle.fontFamily
  }
  if (fontSize) {
    options.fontStyle.size = !isMobileOnly ? fontSize : fontSize - 12
  }
  if (!isEmb && !isBlog && mysterySpin && choices.length > 0) {
    let newMysteryFontSize = fontSizes.mystery.normal
    if (!isMobileOnly) {
      if (fullScreenActive) {
        newMysteryFontSize += fontSizes.mystery.extra
      }
    } else {
      newMysteryFontSize -= 12
    }
    options.fontStyle.size = newMysteryFontSize
  }
  if (choices.length === 0) {
    options.fontStyle.size = !isMobileOnly
      ? fontSizes.ynw.normal
      : fontSizes.ynw.normal - 12
  }

  return (
    <>
      {/* <Profiler id="turntable"> */}
      {isRCW ? (
        <ReactTurntableColorWheel
          {...options}
          prizes={inputMethod === 'ColorWheel' ? ColorWheelData : choices}
          weights={weights}
          onStart={start}
          onComplete={completed}
          width={size}
          height={size}
          music={music}
          isEmb={isEmb}
          isBlog={isBlog}
          weightOn={weightOn}
          wheelColors={wheelColors}
          images={images}
          isBlankWheel={isBlankWheel}
        />
      ) : (
        <ReactTurntable
          {...options}
          prizes={choices}
          weights={weights}
          onStart={start}
          onComplete={completed}
          width={size}
          height={size}
          music={music}
          isEmb={isEmb}
          isBlog={isBlog}
          weightOn={weightOn}
          wheelColors={wheelColors}
          images={images}
          isBlankWheel={isBlankWheel}
          defaultSpinButtonImage={spinButtonImages[page.toUpperCase()]}
        />
      )}
      {/* </Profiler> */}
    </>
  )
}

export default withLocation(Turntable)
